import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../../../axios.js";
import {
  GET_DEPOSIT_BY_DAYS,
  GET_REFUND_BY_DAYS,
  GET_DEPOSIT_TRANSACTION_BY_DEPOSITS,
} from "../../../../Urls.js";

const initialState = {
  depositByDays: { data: [], loading: false, successMessage: "" },
  refundByDays: { data: [], loading: false, successMessage: "" },
  transactionByDeposit: { data: [], loading: false, successMessage: "" },
};

export const getDepositByDays = createAsyncThunk(
  "app/depositSlice/getDepositByDays",
  async (payload) => {
    const response = await axios.post(`${GET_DEPOSIT_BY_DAYS}`, { ...payload });
    return response;
  }
);

export const getRefundByDays = createAsyncThunk(
  "app/depositSlice/getRefundByDays",
  async (data) => {
    const response = await axios.post(GET_REFUND_BY_DAYS, { ...data });
    return response;
  }
);
export const getDepositTransactionByDeposit = createAsyncThunk(
  "app/depositSlice/getDepositTransactionByDeposit",
  async ({ depositId, txnTypeCode }) => {
    const url = `${GET_DEPOSIT_TRANSACTION_BY_DEPOSITS}${depositId}`;
    const response = await axios.get(url, {
      params: { txnTypeCode },
    });
    return response.data;
  }
);

export const depositSlice = createSlice({
  name: "depositSlice",
  initialState,
  reducers: {
    clearData: (state) => {
      state.transactionByDeposit.data = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getDepositByDays.pending, (state) => {
        state.depositByDays.loading = true;
      })
      .addCase(getDepositByDays.fulfilled, (state, action) => {
        state.depositByDays.loading = false;
        state.depositByDays.data = action?.payload?.data?.data;
      })
      .addCase(getDepositByDays.rejected, (state) => {
        state.depositByDays.loading = false;
      })
      .addCase(getRefundByDays.pending, (state) => {
        state.refundByDays.loading = true;
      })
      .addCase(getRefundByDays.fulfilled, (state, action) => {
        state.refundByDays.loading = false;
        state.refundByDays.data = action?.payload?.data?.data;
      })
      .addCase(getRefundByDays.rejected, (state) => {
        state.refundByDays.loading = false;
        state.refundByDays.data = {};
      })
      .addCase(getDepositTransactionByDeposit.pending, (state) => {
        state.transactionByDeposit.loading = true;
      })
      .addCase(getDepositTransactionByDeposit.fulfilled, (state, action) => {
        state.transactionByDeposit.loading = false;
        state.transactionByDeposit.data = action?.payload?.data;
      })
      .addCase(getDepositTransactionByDeposit.rejected, (state) => {
        state.transactionByDeposit.loading = false;
        state.transactionByDeposit.data = [];
      });
  },
});
export const { clearData } = depositSlice.actions;

export default depositSlice.reducer;
